define.alias("ember-power-select/components/power-select-multiple/input", "calendar/components/power-select-multiple/input");